import { render, staticRenderFns } from "./InteraccionesComponent.vue?vue&type=template&id=6fb03827"
import script from "./InteraccionesComponent.vue?vue&type=script&lang=js"
export * from "./InteraccionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb03827')) {
      api.createRecord('6fb03827', component.options)
    } else {
      api.reload('6fb03827', component.options)
    }
    module.hot.accept("./InteraccionesComponent.vue?vue&type=template&id=6fb03827", function () {
      api.rerender('6fb03827', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Dashboard/Interacciones/InteraccionesComponent.vue"
export default component.exports